import { IPromise, IFormController } from 'angular'
import VendDetect from '@vend/detect'
import { Hotkey } from '../hotkeys.service'
import { ALL_HOTKEYS, MODIFIERS } from './hotkeys.constant'

interface HotKeysModalOptions {
  hotkeys: Hotkey[]
}

export class HotkeysModal {
  public readonly allHotkeys = ALL_HOTKEYS
  public suggestedHotkey: string = ''
  public errorSendingSuggestion = false
  public isSendingSuggestion = false
  public isSuggestionSent = false
  public suggestionForm!: IFormController

  constructor(
    public readonly close: () => IPromise<any>,
    public readonly options: HotKeysModalOptions,
    private readonly vdTracking: any
  ) {
    'ngInject'

    this.close = close
    this.options = options
  }

  public getEnvSpecificModifier(key: string): string {
    if (key === MODIFIERS.ALT) {
      return VendDetect.Mac ? MODIFIERS.OPTION : key
    } else {
      return key
    }
  }

  public sendShortcutSuggestion() {
    this.errorSendingSuggestion = false
    this.isSendingSuggestion = true
    this.isSuggestionSent = false

    this.vdTracking
      .trackUserEvent({
        eventName: 'Suggested Shortcut',
        metadata: {
          shortcut: this.suggestedHotkey.replace(/\s+/g, ' ').trim(),
        },
        useBatching: false,
      })
      .then(() => {
        this.isSuggestionSent = true
        this.suggestedHotkey = ''
        this.suggestionForm.$setPristine()
      })
      .catch(() => {
        this.errorSendingSuggestion = true
      })
      .finally(() => {
        this.isSendingSuggestion = false
      })
  }
}
